import { useMemo } from "react";
import QRCode from "qrcode";

type Props = { value: string; label: string };

const QUIET_ZONE = 4;

/**
 * A QR code drawn as one SVG path from the module matrix. Made in the browser: the address
 * is never sent to a QR service, and nothing here renders markup from a string.
 */
export function SolanaQr({ value, label }: Props) {
  const { path, size } = useMemo(() => {
    const { modules } = QRCode.create(value, { errorCorrectionLevel: "M" });
    const commands: string[] = [];
    for (let row = 0; row < modules.size; row += 1) {
      for (let column = 0; column < modules.size; column += 1) {
        if (modules.get(row, column)) {
          commands.push(`M${column + QUIET_ZONE} ${row + QUIET_ZONE}h1v1h-1z`);
        }
      }
    }
    return { path: commands.join(""), size: modules.size + 2 * QUIET_ZONE };
  }, [value]);

  return (
    <svg
      className="solana-qr"
      viewBox={`0 0 ${size} ${size}`}
      role="img"
      aria-label={label}
      shapeRendering="crispEdges"
    >
      <rect width={size} height={size} fill="#ffffff" />
      <path d={path} fill="#000000" />
    </svg>
  );
}
